module.exports = __webpack_public_path__ + "04_bob_black.a4ce4271.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_bob_black.png
// module id = ILtn
// module chunks = 0